import React, { useState, useEffect } from "react";
import { Container } from "./styles";

export const NotificationComponent = () => {
	const [toogle, setToogle] = useState(false);
	const [deferredInstallPrompt, setDeferredInstallPrompt] = useState(null);

	function hadleToogle() {
		setToogle(!toogle);
	}

	// function handleNotifications() {
	// 	let premission = Notification.permission;
	// 	if (premission !== "granted") {
	// 		Notification.requestPermission().catch(console.log);
	// 	} else {
	// 		console.log("Premission denid");
	// 	}
	// }

	useEffect(() => {
		// handleNotifications();

		function saveBeforeInstallPromptEvent(evt) {
			// CODELAB: Add code to save event & show the install button.
			setDeferredInstallPrompt(evt);
			setToogle(true);
		}

		window.addEventListener(
			"beforeinstallprompt",
			saveBeforeInstallPromptEvent,
		);
		window.addEventListener("appinstalled", logAppInstalled);
	}, []);

	function installPWA(evt) {
		// CODELAB: Add code show install prompt & hide the install button.
		deferredInstallPrompt.prompt();
		setToogle(false);
		// CODELAB: Log user response to prompt.
		deferredInstallPrompt.userChoice.then((choice) => {
			if (choice.outcome === "accepted") {
				console.log("User accepted", choice);
			} else {
				console.log("User dismissed", choice);
			}
			setDeferredInstallPrompt(null);
		});
	}

	function logAppInstalled(evt) {
		// CODELAB: Add code to log the event
		console.log("Gerioox App was installed.", evt);
	}

	return (
		<Container
			className='notification'
			style={{ display: `${toogle ? "flex" : "none"}` }}>
			<img
				loading='lazy'
				onClick={hadleToogle}
				className='notification__close'
				srcSet={`${
					require("@/assets/img/icon-close.png").default
				} 320w, 
                        ${
							require("@/assets/img/icon-close@2x.png").default
						} 480w, 
                        ${
							require("@/assets/img/icon-close@3x.png").default
						} 800w`}
				src={require("@/assets/img/icon-close.png").default}
				alt='icone fechar'
			/>
			<div className='notification__message'>
				<img
					loading='lazy'
					className='img-fluid'
					srcSet={`${
						require("@/assets/img/icon-gerioox.png").default
					} 320w, 
                            ${
								require("@/assets/img/icon-gerioox@2x.png")
									.default
							} 480w, 
                            ${
								require("@/assets/img/icon-gerioox@3x.png")
									.default
							} 800w`}
					src={require("@/assets/img/icon-gerioox.png").default}
					alt='gerioox icone'
				/>
				<span>
					Adicione o Programa de Fidelidade Gerioox na sua tela
					inicial
				</span>
			</div>
			<button
				onClick={() => installPWA()}
				className='add-button notification__action'>
				adicionar
			</button>
		</Container>
	);
};

export default NotificationComponent;
